<template>
  <Form style="line-height:32px"
        :label-width="120"
        inline>
    <!--<FormItem label="取消类型" style="width:90%" prop="type">
            <RadioGroup v-model="type">
                <Radio label="0">仅取消BOSS订单</Radio>
                <Radio label="1">同步取消仓库订单</Radio>
            </RadioGroup>
        </FormItem>-->
    <FormItem label='取消原因'
              style="width:90%"
              prop="remark">
      <Input v-model="remark"
             :rows="3"
             type="textarea" />
    </FormItem>
    <!--<div class="color-error text-left" style="margin-left: 60px;line-height: 20px">
            注意：<br>
            1.选择“仅取消BOSS订单”会直接将订单状态改为已取消，云仓和仓库的对应单据状态不会改变；<br>
            2.选择“同步取消仓库订单”会发取消消息给云仓和仓库，返回取消成功或失败的提示；<br>
            3.“同步取消仓库订单”只针对云仓对接的仓库。没有对接的仓库无法同步取消。<br>
        </div>-->
    <footer class="text-right">
      <Button type="primary"
              @click="submit">提交</Button>
      <Button class="margin-left-10"
              @click="cancel">取消</Button>
    </footer>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </Form>
</template>
<script>
import { HttpCancelOrder } from '@/service/boss/b2corder'
import { mapState } from 'vuex'
export default {
  props: ['id'],
  data () {
    return {
      loading: false,
      show: true,
      remark: '',
      type: "1",
      required: [{
        required: true,
        message: "该信息不能为空,请填写"
      }],
    }
  },
  methods: {
    cancel () {
      this.$emit('on-close')
    },
    async submit () {
      this.loading = true;
      HttpCancelOrder({
        orderId: this.id,
        cancelType: this.type,
        remark: this.remark,
      }).then(res => {
        this.$Message.success(res.message);
        this.cancel();
        this.$emit('on-update');
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>

